import React, { useMemo } from 'react'
import { getFlightLoyaltyProductType } from 'lib/flights/flightUtils'
import LoyaltyPointsEarn from 'loyalty/components/Earn/LoyaltyPointsEarn'

interface Props {
  flightDeal: App.FlightDeal
}

function FlightDealPoints({ flightDeal }: Props) {
  const pointsEarnCalculationRequests = useMemo<Array<App.LoyaltyPointsEarnCalculationRequest>>(() => {
    const isDomestic = flightDeal.originCountry === flightDeal.destinationCountry
    const type = getFlightLoyaltyProductType(flightDeal.fareClass.toLowerCase() || '', isDomestic)

    return [{
      loyaltyProductType: type,
      price: flightDeal.perAdultPrice,
    }]
  }, [flightDeal])

  return (
    <LoyaltyPointsEarn calculationRequests={pointsEarnCalculationRequests} calculationType="estimate" />
  )
}

export default FlightDealPoints
